import React, { useState } from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { Button } from "antd";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { useNavigate } from "react-router-dom";

const features = [
  {
    id: "01",
    title: "Transparent Pricing",
    description: "No hidden fees, just simple and affordable ticketing.",
  },
  {
    id: "02",
    title: "Instant Payouts",
    description: "Get paid immediately with Stripe integration.",
  },
  {
    id: "03",
    title: "Effortless Management",
    description:
      "Track sales, update event details, and scan tickets with ease.",
  },
  {
    id: "04",
    title: "Built-in Marketing Tools",
    description: "Promote, sell, and communicate with attendees seamlessly.",
  },
];

const WhyChooseQuikTix = () => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(null);
  return (
    <>
      <Box sx={styles.container}>
        <Container maxWidth="lg">
          <Typography align="center" variant="h4" sx={styles.title}>
            Why Choose{" "}
            <span style={{ color: "#535353" }} className="count-shine">
              GX Tickets?
            </span>
          </Typography>
          <Typography
            align="center"
            variant="body1"
            color="text.secondary"
            sx={{ mt: 2 }}
          >
            Perfect for attractions, festivals, theaters, museums, and more.
            Whether online or on-site, GX Tickets makes ticketing a breeze.
          </Typography>

          <Box sx={{ textAlign: "center", pt: 8, mx: "auto" }}>
            <Grid
              container
              spacing={3}
              justifyContent="center"
              alignItems="stretch"
            >
              {features.map((feature, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={3}
                  xl={3}
                  key={index}
                  sx={{ display: "flex" }}
                >
                  <Box
                    sx={{
                      p: 4,
                      pt: 8,
                      textAlign: "left",
                      backgroundColor: "#fff",
                      boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.05)",
                      transition: "all 0.3s ease",
                      position: "relative",
                      cursor: "pointer",
                      borderBottom:
                        hovered === index
                          ? "3px solid #333"
                          : "3px solid #33333326",
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      "&:hover": {
                        borderBottom: "3px solid #333",
                        transform: "translateY(-5px)",
                      },
                    }}
                    onMouseEnter={() => setHovered(index)}
                    onMouseLeave={() => setHovered(null)}
                  >
                    <Typography
                      variant="h1"
                      sx={{
                        fontSize: "6rem",
                        fontWeight: 700,
                        color: "#f5f5f5",
                        position: "absolute",
                        top: 15,
                        left: 20,
                        zIndex: 0,
                      }}
                    >
                      {feature.id}
                    </Typography>
                    <Box
                      sx={{ position: "relative", zIndex: 1, width: "100%" }}
                    >
                      <Typography
                        variant="h6"
                        fontWeight={600}
                        color="#333"
                        sx={{
                          marginBottom: "10px",
                          minHeight: "50px",
                          display: "flex",
                          alignItems: "flex-end",
                        }}
                      >
                        {feature.title}
                      </Typography>
                      <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ textAlign: {xs: "left", md: "justify"}, hyphens: 'auto' }}
                      >
                        {feature.description}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default WhyChooseQuikTix;

const styles = {
  container: {
    /* bgcolor: "#f9f9f9", */
  },
  title: {
    fontWeight: 700,
    // fontSize: { xs: "2rem", md: "2.5rem" },
    fontSize: { xs: 24, sm: 32, md: 40 },
  },
  subtitle: {
    color: "#535353",

    fontWeight: 500,
    fontSize: { xs: "1rem", md: "1.5rem" },
  },
  featureBox: {
    textAlign: "center",
  },
  featureTitle: {
    fontWeight: 600,
    fontSize: "1.5rem",
  },
  featureDescription: {
    fontWeight: 400,
    fontSize: "1.25rem",
  },
};
